class LogoMobileWidth {
	static instance = null;

	static create() {
		if (!LogoMobileWidth.instance) {
			LogoMobileWidth.instance = this;
		}
		return LogoMobileWidth.instance;
	}

	static destroy() {
		if (LogoMobileWidth.instance) {
			LogoMobileWidth.instance = null;
		}
	}

	constructor() {
		this.init();
	}

	init() {
		$('[data-width-mb]').each(function () {
			let item = $(this);
			let width = $(item).attr('width');
			let mbwidth = $(item).data('width-mb');
			var resizeHandler = function () {
				let win = $(window).width();
				if (win < 768) {
					$(item).attr('width', mbwidth);
				} else {
					$(item).attr('width', width);
				}
			};

			resizeHandler();
			$(window).on('resize orientationchange', resizeHandler);
		});
	}

	beforeDestroy() {
		$(window).off('resize orientationchange');
	}
}

export default LogoMobileWidth;